module.exports = __webpack_public_path__ + "img/fashion_style.33760a48.svg";